import {IDateRange, IMessage, IMessageProvider, MessageType} from "../PA.Core.IF.Basic";
import {DateUtils} from "./Dates";
import * as _ from "lodash";
import {title} from "process";


export interface ValidateRangeOptions {
    validateRange?: IDateRange
    validationRangeName?: string
    bLogError?: boolean
}


export function ErrorMessage_restate(aMP: IMessageProvider, bLogMessage: boolean, sMsgCode: string, sMessage: string | { Title: string, Desc: string }) {
    Message_restate(aMP, bLogMessage, sMsgCode, sMessage, MessageType.Error)
}

export function WarningMessage_restate(aMP: IMessageProvider, bLogMessage: boolean, sMsgCode: string, sMessage: string | { Title: string, Desc: string }) {
    Message_restate(aMP, bLogMessage, sMsgCode, sMessage, MessageType.Warning)
}

export function InfoMessage_restate(aMP: IMessageProvider, bLogMessage: boolean, sMsgCode: string, sMessage: string | { Title: string, Desc: string }) {
    Message_restate(aMP, bLogMessage, sMsgCode, sMessage, MessageType.Information)
}

export function ExceptionMessage_restate(aMP: IMessageProvider, exception: Error | string) {
    let msgId = "Exception"
    let msgTitle = "Exception Caught"
    let msgDesc = "Exception Caught " + exception.toString()

    if (_.isString(exception)) {
        msgTitle = exception
        msgDesc = title
    }


    let ex = exception || {}
    if (_.isObjectLike(exception)) {
        try {
            if ('message' in ex) {
                msgTitle = ('' + ex.message) || ""
                msgDesc = msgTitle
            }

            if ('stack' in ex) {
                msgDesc = msgDesc + '\nstack: ' + ex.stack
            }
        } catch (e) {}
    }


    Message_restate(aMP, true, msgId, {Title: msgTitle, Desc: msgDesc}, MessageType.Error)
}


export function Message_restate(aMP: IMessageProvider, bLogMessage: boolean, sMsgCode: string, sMessage: string | { Title: string, Desc: string }, aMessageType: MessageType) {
    if (!aMP) return
    if (bLogMessage) {
        let aMsg: IMessage
        if (_.isString(sMessage)) {
            aMsg = {
                code: sMsgCode,
                type: aMessageType,
                title: sMessage,
                description: sMessage,
                subtitle: "",
                count: 0
            }
        } else {
            aMsg = {
                code: sMsgCode,
                type: aMessageType,
                title: sMessage.Title,
                description: sMessage.Desc,
                subtitle: "",
                count: 0
            }
        }
        aMP.addMessage(aMsg)
    } else {
        aMP.removeMessage(sMsgCode)
    }
}

export function ValidateDateRange(aMP: IMessageProvider, sDateRangeName: string, dStartDate: Date, dEndDate: Date, options: ValidateRangeOptions): boolean {

    let opts: ValidateRangeOptions = {}
    _.defaults(opts, options)
    let validationRangeName = opts.validationRangeName || 'valid Range'

    if (!_.isDate(dStartDate) || !_.isDate(dEndDate)) {
        ErrorMessage_restate(aMP, opts.bLogError, sDateRangeName, sDateRangeName + ' are not set.')
        return false
    }

    if (!_.isEmpty(opts.validateRange)) {

        if (!DateUtils.InRange(dStartDate, opts.validateRange)) {
            let sStartDate = DateUtils.formatDate(dStartDate)
            ErrorMessage_restate(aMP, opts.bLogError, sDateRangeName + 'Start', `${sDateRangeName} -  Start Dt (${sStartDate}) out of ${validationRangeName}, ${DateUtils.formatRange(opts.validateRange)}`)
            return false
        }

        if (!DateUtils.InRange(dEndDate, opts.validateRange)) {
            let sEndDate = DateUtils.formatDate(dEndDate)
            ErrorMessage_restate(aMP, opts.bLogError, sDateRangeName + 'End', `${sDateRangeName} - End Dt (${sEndDate}) out of ${validationRangeName} , ${DateUtils.formatRange(opts.validateRange)}`)
            return false
        }
    }

    if (dStartDate.getTime() > dEndDate.getTime()) {
        ErrorMessage_restate(aMP, opts.bLogError, sDateRangeName + 'Order', sDateRangeName + ' - Start Date after End Date.')
        return false
    }

    return true
}

